var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.paragraphs),function(paragraph,i){return _c('p',{key:i,staticClass:"text-body-2 mb-2"},[_vm._v(_vm._s(paragraph))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }